import { call, put } from 'redux-saga/effects';
import { cancelReturnFailure, cancelReturnSuccess, updateVatReturnLogStatus } from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { CancelReturnRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { cancelReturn } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import routes from 'routes';
import { push } from 'store/navigation/actions';
import { updateSubmissionLog } from 'store/organisation/actions';
import { DataLogStatus, SubmissionUpdateField } from 'store/app/enums';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { endCancelReturnNavigation } from 'pages/vat/cancel-return-navigation';
import { cancelTifdReportFromReturnSaga } from 'store/tifd/sagas/cancelTifdReportSaga';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* cancelReturnSaga(action: CancelReturnRequestAction) {
  const cancelledTifd: boolean = yield call(
    cancelTifdReportFromReturnSaga,
    action
  );
  if (cancelledTifd) return;

  try {
    let err: ApiError | null;
    const { dataLogId, mappingId, organisationId } = action.payload;

    const response: ApiResponse = yield call(
      cancelReturn,
      dataLogId,
      mappingId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(
      updateSubmissionLog(
        mappingId,
        SubmissionUpdateField.STATUS,
        DataLogStatus.CANCELLED,
        dataLogId
      )
    );
    yield put(
      updateVatReturnLogStatus(
        dataLogId,
        mappingId,
        DataLogStatus.CANCELLED
      )
    );

    const afterCancelPath = organisationId
      ? routes.organisations.organisation.replace(':id', organisationId)
      : routes.main;

    yield put(push(afterCancelPath));
    yield put(cancelReturnSuccess());
  } catch (error: any) {
    endCancelReturnNavigation();
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(cancelReturnFailure());
  }
}
